import { Box, Fade, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const MaintenancePage = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%)
          `,
        },
      }}
    >
      {/* Animated background particles */}
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)',
            animation: 'float 6s ease-in-out infinite',
          },
          '&::before': {
            top: '10%',
            left: '10%',
            animationDelay: '0s',
          },
          '&::after': {
            bottom: '10%',
            right: '10%',
            animationDelay: '3s',
          },
          '@keyframes float': {
            '0%, 100%': {
              transform: 'translateY(0px) rotate(0deg)',
            },
            '50%': {
              transform: 'translateY(-20px) rotate(180deg)',
            },
          },
        }}
      />

      {/* Main content */}
      <Fade in={fadeIn} timeout={1000}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            zIndex: 1,
            maxWidth: '600px',
            padding: '40px',
            borderRadius: '20px',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            mx: 2,
          }}
        >
          {/* Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
            <img
              src="/logoIcon.png"
              alt="Qualz Logo"
              style={{ height: '2.5rem', marginRight: '16px' }}
            />
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              We&apos;ll Be Right Back
            </Typography>
          </Box>

          {/* Subtitle */}
          <Typography
            variant="h6"
            sx={{
              color: '#666',
              mb: 1,
              fontWeight: 500,
            }}
          >
            Site Maintenance in Progress
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              color: '#888',
              mb: 1,
              lineHeight: 1.6,
              maxWidth: '500px',
            }}
          >
            We&apos;re currently performing essential updates and maintenance to enhance your
            experience. Thank you for your patience as we work to serve you better.
          </Typography>

          {/* Timeline */}
          <Box
            sx={{
              background: '#f7fafc',
              borderLeft: '4px solid #667eea',
              padding: '16px 24px',
              mb: 3,
              marginLeft: 'auto',
              marginRight: 'auto',
              borderRadius: '0 8px 8px 0',
              textAlign: 'left',
              maxWidth: { xs: '100%', sm: '450px' },
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#4a5568',
                fontSize: '0.9rem',
                m: 0,
              }}
            >
              Maintenance should be completed Soon. Please check back later.
            </Typography>
          </Box>

          {/* Additional description with contact link */}
          <Typography
            variant="body1"
            sx={{
              color: '#888',
              lineHeight: 1.6,
              maxWidth: '500px',
              mb: 4,
            }}
          >
            In the meantime, feel free to{' '}
            <a
              href="mailto:service@qualz.ai"
              style={{
                color: '#667eea',
                textDecoration: 'none',
                fontWeight: 600,
              }}
            >
              contact us
            </a>{' '}
            if you need assistance.
          </Typography>
        </Box>
      </Fade>
    </Box>
  );
};

export default MaintenancePage;
